/**
 * @generated SignedSource<<7a827abb83d04ed52400d667a4e578d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardStudentsListWeeklyQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
  passed?: number | null | undefined;
  skip: boolean;
};
export type DashboardStudentsListWeeklyQuery$data = {
  readonly studentsSkillAssessmentsWeeklySnapshotDetail?: ReadonlyArray<{
    readonly skills: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly name: string | null | undefined;
    }>;
    readonly student: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined;
  }>;
};
export type DashboardStudentsListWeeklyQuery = {
  response: DashboardStudentsListWeeklyQuery$data;
  variables: DashboardStudentsListWeeklyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "passed"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "passedSkills",
    "variableName": "passed"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Student",
  "kind": "LinkedField",
  "name": "student",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicUserId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardStudentsListWeeklyQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TeacherDashboardSnapshotDetail",
            "kind": "LinkedField",
            "name": "studentsSkillAssessmentsWeeklySnapshotDetail",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardStudentsListWeeklyQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TeacherDashboardSnapshotDetail",
            "kind": "LinkedField",
            "name": "studentsSkillAssessmentsWeeklySnapshotDetail",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f0e73ae192aa827d1e46d24557c05e40",
    "id": null,
    "metadata": {},
    "name": "DashboardStudentsListWeeklyQuery",
    "operationKind": "query",
    "text": "query DashboardStudentsListWeeklyQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n  $passed: Int = null\n  $skip: Boolean!\n) {\n  studentsSkillAssessmentsWeeklySnapshotDetail(filter: $filter, passedSkills: $passed) @skip(if: $skip) {\n    student {\n      firstName\n      lastName\n      id\n      publicUserId\n    }\n    skills {\n      name\n      code\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f4c79847dc5446a899ee9c02aee631d";

export default node;
